<button mat-raised-button [matMenuTriggerFor]="categoriesMenu" color="primary" style="height: auto; padding: 4px 12px">
  <mat-icon>category</mat-icon>
  Shop Categories <br />
  @if (selectedCategories().size === 0) {
    (All)
  } @else {
    ({{ selectedCategories().size }} / {{ shopCategoriesCount() }})
  }
</button>
<mat-menu #categoriesMenu="matMenu">
  <!-- Clear -->
  <button mat-menu-item (click)="clearSelection(); $event.stopPropagation()">
    <mat-icon>close</mat-icon>
    <span>Clear Selection</span>
  </button>
  <mat-divider></mat-divider>
  @for (category of topShopCategories(); track category.name) {
    <div>
      <!-- Level 1: Category -->
      <div mat-menu-item [matMenuTriggerFor]="subCategories1Menu">
        <span>{{ category.displayName() }}</span>
        @if (category.subCategories && category.subCategories.length > 0) {
          <mat-icon>chevron_right</mat-icon>
        }
      </div>

      <mat-menu #subCategories1Menu="matMenu">
        <div>
          <button mat-menu-item (click)="selectAllSubCats(category); $event.stopPropagation()">
            <mat-icon>done_all</mat-icon>
            <span>Select All in {{ category.displayName() }}</span>
          </button>
          <button mat-menu-item (click)="removeAllSubCats(category); $event.stopPropagation()">
            <mat-icon>close</mat-icon>
            <span>Remove All in {{ category.displayName() }}</span>
          </button>
          <mat-divider></mat-divider>
        </div>

        @let filteredSubCategories1 = filterSubCategories(category);
        @for (subCategory1 of filteredSubCategories1; track subCategory1.name) {
          @let hasChildren1 = filterSubCategories(subCategory1).length > 0;
          @if (hasChildren1) {
            <!-- Level 2: SubCategory1 with children -->
            <div mat-menu-item [matMenuTriggerFor]="subCategories2Menu">
              <span>{{ subCategory1.displayName() }}</span>
              <mat-icon>chevron_right</mat-icon>
            </div>
            <mat-menu #subCategories2Menu="matMenu">
              <div>
                <button mat-menu-item (click)="selectAllSubCats(subCategory1); $event.stopPropagation()">
                  <mat-icon>done_all</mat-icon>
                  <span>Select All in {{ subCategory1.displayName() }}</span>
                </button>
                <button mat-menu-item (click)="removeAllSubCats(subCategory1); $event.stopPropagation()">
                  <mat-icon>close</mat-icon>
                  <span>Remove All in {{ subCategory1.displayName() }}</span>
                </button>
                <mat-divider></mat-divider>
              </div>
              @let filteredSubCategories2 = filterSubCategories(subCategory1);
              @for (subCategory2 of filteredSubCategories2; track subCategory2.name) {
                @let hasChildren2 = filterSubCategories(subCategory2).length > 0;
                @if (hasChildren2) {
                  <!-- Level 3: SubCategory2 with children -->
                  <div mat-menu-item [matMenuTriggerFor]="subCategories3Menu">
                    <span>{{ subCategory2.displayName() }}</span>
                    <mat-icon>chevron_right</mat-icon>
                  </div>
                  <mat-menu #subCategories3Menu="matMenu">
                    <div>
                      <button mat-menu-item (click)="selectAllSubCats(subCategory2); $event.stopPropagation()">
                        <mat-icon>done_all</mat-icon>
                        <span>Select All in {{ subCategory2.displayName() }}</span>
                      </button>
                      <button mat-menu-item (click)="removeAllSubCats(subCategory2); $event.stopPropagation()">
                        <mat-icon>close</mat-icon>
                        <span>Remove All in {{ subCategory2.displayName() }}</span>
                      </button>
                      <mat-divider></mat-divider>
                    </div>
                    @let filteredSubCategories3 = filterSubCategories(subCategory2);
                    @for (subCategory3 of filteredSubCategories3; track subCategory3.name) {
                      <!-- Level 4: SubCategory3 (leaf) -->
                      <button mat-menu-item (click)="toggleCategorySelection(subCategory3); $event.stopPropagation()" [class.selected]="isCategorySelected(subCategory3)">
                        <mat-icon>
                          @if (isCategorySelected(subCategory3)) {
                            check_box
                          } @else {
                            check_box_outline_blank
                          }
                        </mat-icon>
                        <span>{{ subCategory3.displayName() }}</span>
                      </button>
                    }
                  </mat-menu>
                } @else {
                  <!-- Level 3: SubCategory2 (leaf) -->
                  <button mat-menu-item (click)="toggleCategorySelection(subCategory2); $event.stopPropagation()" [class.selected]="isCategorySelected(subCategory2)">
                    <mat-icon>
                      @if (isCategorySelected(subCategory2)) {
                        check_box
                      } @else {
                        check_box_outline_blank
                      }
                    </mat-icon>
                    <span>{{ subCategory2.displayName() }}</span>
                  </button>
                }
              }
            </mat-menu>
          } @else {
            <!-- Level 2: SubCategory1 (leaf) -->
            <button mat-menu-item (click)="toggleCategorySelection(subCategory1); $event.stopPropagation()" [class.selected]="isCategorySelected(subCategory1)">
              <mat-icon>
                @if (isCategorySelected(subCategory1)) {
                  check_box
                } @else {
                  check_box_outline_blank
                }
              </mat-icon>
              <span>{{ subCategory1.displayName() }}</span>
            </button>
          }
        }
      </mat-menu>
    </div>
  }
</mat-menu>
